import { createAction, props } from '@ngrx/store'
import { Bank } from './bank.state'

// Action to load Department
export const loadBanks = createAction(
  '[Bank] Load Bank',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful Bank load
export const loadBanksSuccess = createAction(
  '[Bank] Load Bank Success',
  props<{
    banks: Bank[]
  }>()
)

// Action for Department load failure
export const loadBanksFailure = createAction('[Bank] Load Bank Failure', props<{ error: string }>())

export const createBank = createAction(
  '[Bank] Create Bank',
  props<{
    payload: any
  }>()
)

export const createBankSuccess = createAction('[Bank] Create Bank Success', props<{ bank: Bank }>())

export const createBankFailure = createAction('[Bank] Create Bank Failure', props<{ error: any }>())

export const updateBank = createAction('[Bank] Update Bank', props<{ id: string; payload: any }>())

export const updateBankSuccess = createAction('[Bank] Update Bank Success', props<{ bank: Bank }>())

export const updateBankFailure = createAction('[Bank] Update Bank Failure', props<{ error: any }>())

export const deleteBank = createAction('[Bank] Delete Bank', props<{ id: string }>())

export const deleteBankSuccess = createAction('[Bank] Delete Bank Success', props<{ id: string }>())

export const deleteBankFailure = createAction('[Bank] Delete Bank Failure', props<{ error: any }>())
